/// <reference path="../../../../typings/index.d.ts" />

module Meevo.Plugins.ConfirmationManager {
    angular.module("meevo.plugins.confirmationManager", []);
}